import React, { useEffect, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import AllSummaryPage from "./AllSummaryPage";
import { getTenantById } from "./api/tenantApi";
import BrandThinkingLoader from "./components/BrandThinkingLoader";

export default function TenantLandingPage() {
  const { isAuthenticated, loginWithRedirect } = useAuth0();
  const isAdmin = useSelector((state) => state.userInfo.isAdmin);
  const isDistributor = useSelector((state) => state.userInfo.isDistributor);
  const tenantId = useSelector((state) => state.userInfo.tenantId);
  const [tenantType, setTenantType] = useState(null);
  const [tenantResolved, setTenantResolved] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect();
    }
  }, [isAuthenticated, loginWithRedirect]);

  useEffect(() => {
    let active = true;

    if (!isAuthenticated || isAdmin || isDistributor || !tenantId) {
      setTenantResolved(true);
      return () => {
        active = false;
      };
    }

    setTenantResolved(false);
    getTenantById(tenantId)
      .then((result) => {
        if (!active) return;
        const tenant = result?.data || result;
        setTenantType(tenant?.tenantType || "regular");
        setTenantResolved(true);
      })
      .catch(() => {
        if (!active) return;
        // Preserve the established dashboard when tenant metadata is temporarily
        // unavailable instead of blocking access to the application.
        setTenantType("regular");
        setTenantResolved(true);
      });

    return () => {
      active = false;
    };
  }, [isAdmin, isAuthenticated, isDistributor, tenantId]);

  if (!isAuthenticated) {
    return <BrandThinkingLoader fullScreen />;
  }

  if (isDistributor) {
    return <Navigate to="/distributor" replace />;
  }

  if (isAdmin) {
    return <Navigate to="/platform" replace />;
  }

  if (!tenantResolved) {
    return <BrandThinkingLoader fullScreen />;
  }

  if (tenantType === "payment_platform" && tenantId) {
    return <Navigate to={`/tenant-dashboard/${encodeURIComponent(tenantId)}`} replace />;
  }

  return <AllSummaryPage adminAction />;
}
